import { belongsToCustomer, userHasPermission } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAll: ({ user }) => {
    return userHasPermission(user, "controlling.all.read");
  },
  viewAny: ({ user }) => {
    return (
      userHasPermission(user, "controlling.all.read") ||
      userHasPermission(user, "controlling.customer.read")
    );
  },
  viewCustomer: ({ user, customerId }) => {
    if (userHasPermission(user, "controlling.all.read")) {
      return true;
    }
    return (
      belongsToCustomer(user, customerId) &&
      userHasPermission(user, "controlling.customer.read")
    );
  },
  exportAny: (user) => {
    return (
      userHasPermission(user, "controlling.all.export") ||
      userHasPermission(user, "controlling.customer.export")
    );
  },
  exportAll: (user) => {
    return userHasPermission(user, "controlling.all.export");
  },
  exportCustomer: ({ user, customerId }) => {
    if (userHasPermission(user, "controlling.all.export")) {
      return true;
    }
    return (
      belongsToCustomer(user, customerId) &&
      userHasPermission(user, "controlling.customer.export")
    );
  },
};
